<template>
  <el-dialog title="确认签约" :visible.sync="visible" width="500px">
    <el-form :model="data" :rules="rules" ref="signForm" label-width="110px">
        <el-form-item label="签约日期:" prop="contractSignDate">
            <el-date-picker v-model="data.contractSignDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="签约文件:" prop="fileObjs">
            <FileUpload v-model="data.fileObjs" :limit="5" :readOnly="false" @on-change="handleFileChange"></FileUpload>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { changeStatus } from "@/api/crm/contract";
import FileUpload from "@/views/crm/components/fileUpload";

export default {
    name: "ConfirmContract",
    props: {
    },
    data() {
        return {
            visible: false,
            rules: {
                contractSignDate: [
                    {required: true, message: '请选择签约日期', trigger: 'change'}
                ],
                fileObjs: [
                    {required: true,type: 'array', message: '请选择签约文件', trigger: 'change'}
                ]
            },
            data: {
                contractId: null,
                operateType: 3,
                fileObjs: [],
                contractSignDate: null
            }
        };
    },
    components: {
        FileUpload
    },
    watch: {
        visible (val) {
            if (!val) {
                this.resetForm("signForm");
            }
        }
    },
    methods: {
        handleFileChange (fileObjs) {
            this.data.fileObjs = fileObjs;
        },
        options (id) {
            if (!id) {
                this.msgError("当前合同id异常")
                return
            }
            this.data.contractId = id
            this.visible = true
        },
        confirm () {
            this.$refs['signForm'].validate((valid) => {
                if (valid) {
                    let params = JSON.parse(JSON.stringify(this.data));
                    if (params.fileObjs && params.fileObjs.length > 0) {
                        params.contractFileIds = params.fileObjs.map(item => {
                            return { id: item.id };
                        })
                    } else {
                        this.msgError("请上传合同文件")
                        return
                    }
                    const loading = this.$loading({
                        lock: true,
                        text: '加载中',
                        spinner: 'el-icon-loading'
                    });
                    changeStatus(params).then(response => {
                        this.$emit('success')
                        this.visible = false
                        loading.close();
                        this.msgSuccess(response.msg || "签约成功");
                    }).catch(error => {
                        loading.close()
                    })
                }
            });
        }
    }
};
</script>
